import script from "./FormView.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormView.vue?vue&type=script&setup=true&lang=ts"

import "./FormView.vue?vue&type=style&index=0&id=5a2e3702&lang=css"

const __exports__ = script;

export default __exports__